import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AiColPromptPreviewModal from './ai-col-prompt-preview-modal';
import { AiColPromptPreviewModalProps } from './types';
import {
  getAiColumnPreviewRequest,
  getSingleProspectDetailsRequest,
} from '../../../../extra-actions';
import { getAiColumnPreviewProps } from '../../../../types';
import {
  resetAiColumnPreviewRequest,
  resetAiColumnTemplatePreview,
  resetSingleProspectDetailsRequest,
} from '../../../../prospect-slice';
import { RootState } from '../../../../../../store/root-reducer';

const AiColPromptPreviewModalContainer = memo(
  (props: AiColPromptPreviewModalProps) => {
    const dispatch = useDispatch();

    const getSingleProspectDetailsRequests = useCallback(
      (id: number) => {
        dispatch(getSingleProspectDetailsRequest(id));
      },
      [dispatch],
    );

    const getAiColumnPreviewRequests = useCallback(
      (payload: getAiColumnPreviewProps) => {
        dispatch(getAiColumnPreviewRequest(payload));
      },
      [dispatch],
    );

    const resetSingleProspectDetailsRequests = useCallback(() => {
      dispatch(resetSingleProspectDetailsRequest());
    }, [dispatch]);

    const resetAiColumnTemplatePreviewRequest = useCallback(() => {
      dispatch(resetAiColumnTemplatePreview());
    }, [dispatch]);

    const resetAiColumnPreview = useCallback(() => {
      dispatch(resetAiColumnPreviewRequest());
    }, []);

    // const { hasMore } = useSelector(
    //   (state: RootState) => state?.prospect?.aiTemplatesPagination,
    // );
    const prospectList = useSelector(
      (state: RootState) => state?.prospect?.prospects,
    );
    const getSingleProspectDetailsRequestStatus = useSelector(
      (state: RootState) =>
        state?.prospect?.getSingleProspectDetailsRequest.status,
    );

    const aiColumnTemplatePreviewRequestStatus = useSelector(
      (state: RootState) => state?.prospect?.getAiColumnPreviewRequest.status,
    );
    const aiColumnTemplatePreviewResponse = useSelector(
      (state: RootState) => state?.prospect?.aiColumnTemplatePreview,
    );
    const fields = useSelector((state: RootState) => state.prospect.fields);
    const selectors = useSelector(
      (state: RootState) => state.prospect.singleProspect,
    );
    return (
      <AiColPromptPreviewModal
        {...props}
        getSingleProspectDetailsRequests={getSingleProspectDetailsRequests}
        getAiColumnPreviewRequests={getAiColumnPreviewRequests}
        resetSingleProspectDetailsRequests={resetSingleProspectDetailsRequests}
        resetAiColumnTemplatePreviewRequest={
          resetAiColumnTemplatePreviewRequest
        }
        resetAiColumnPreview={resetAiColumnPreview}
        prospectList={prospectList}
        getSingleProspectDetailsRequestStatus={
          getSingleProspectDetailsRequestStatus
        }
        aiColumnTemplatePreviewRequestStatus={
          aiColumnTemplatePreviewRequestStatus
        }
        aiColumnTemplatePreviewResponse={aiColumnTemplatePreviewResponse}
        fields={fields}
        selectors={selectors}
      />
    );
  },
);

export default AiColPromptPreviewModalContainer;
